// extracted by mini-css-extract-plugin
export default {"profile":"Frontpage_profile__Vc+p4","description":"Frontpage_description__ln+N2","actions":"Frontpage_actions__oZVx9"};